import type { CSSProperties } from 'react';
import type { BuildingZone } from '@kaeliux/shared';

/**
 * Maps a zone to the `--zone-*` custom property (`index.css`) that should
 * back `--zone-accent` for anything rendered inside that zone. `--zone-accent`
 * itself is a single global var (defaulted to the resource zone) — surface
 * tiles set it locally per zone so a military-zone building doesn't borrow
 * the resource zone's color.
 */
export const ZONE_ACCENT_VAR: Record<BuildingZone, string> = {
    resource: 'var(--zone-resource)',
    industry: 'var(--zone-industry)',
    military: 'var(--zone-military)',
};

/** Inline style that scopes `--zone-accent` to the given zone for this subtree. */
export function zoneAccentStyle(zone: BuildingZone): CSSProperties {
    return { '--zone-accent': ZONE_ACCENT_VAR[zone] } as CSSProperties;
}
